<template lang="html">

  <section class="login">
    <div class="pageHeading">
    <h1>Returning Users</h1>
    </div>
    <v-form @submit.prevent="tryLogin">
      <v-text-field
              v-validate="'required|email'"
              v-model="email"
              :error-messages="errors.collect('email')"
              label="E-mail"
              data-vv-name="email"
              required
      ></v-text-field>
      <v-text-field
              v-model="password"
              label="Password"
              data-vv-name="password"
              type="password"
              required
      ></v-text-field>

      <p style="color: red" v-if="error.length > 0">{{error}}</p>


      <v-btn :disabled="waiting" color="secondary" dark @click="$router.push('/Recovery')">Lost My Password</v-btn>
      <v-btn  :disabled="waiting" type="submit" color="primary">Sign In</v-btn>
    </v-form>

    <br/>
    <p>New user? <router-link to="/Register">Create Account!</router-link></p>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'login',
    props: [],
    mounted() {


        if(this.$userData._id != undefined)
        this.$router.push('/')
    },
    data() {
      return {
          error: '',
          name: '',
          email: '',
          waiting: false,
          password: '',
          dictionary: {
              attributes: {
                  email: 'E-mail Address'
                  // custom attributes
              },
              custom: {
                  name: {
                      required: () => 'Name can not be empty',
                      max: 'The name field may not be greater than 10 characters'
                      // custom messages
                  },
                  select: {
                      required: 'Select field is required'
                  }
              }
          }
      }
    },
    methods: {
        tryLogin() {
            var thisVue = this;
            thisVue.waiting = true
            console.log('about to try login with',this.email, this.password )
            return this.$feathers.authenticate({
                strategy: 'local',
                email: this.email.trim().toLowerCase(), //'admin@test.com',
                password: this.password, //'adminpass',
                entity: 'user',
                service: 'users',

            })
                .then(response => {
                    console.log('Authenticated!', response);
                    return this.$feathers.passport.verifyJWT(response.accessToken);
                })
                .then(payload => {
                    //console.log('JWT Payload', payload);
                    return this.$feathers.service('users').get(payload.userId);
                })
                .then(user => {
                    this.$feathers.set('user', user);
                    console.log('User Is', this.$userData);
                    this.$userData = this.$feathers.get('user')
                    console.log('User Is NOW', this.$userData);
                    this.$busyDialog = true
                    this.$fetchData()

                    if(this.$feathers.get('user').setup)
                        thisVue.$router.push('/')
                    else
                        thisVue.$router.push('/Setup')
                    thisVue.waiting = false
                })
                .catch(function(error){
                    thisVue.waiting = false
                    console.log('Error authenticating! from login page', error);
                    if(error.data !== undefined)
                        thisVue.error = error.message;
                    else
                        thisVue.error = "Sorry, the server encountered an error. Please try again later."
                });
        }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.login {
}
</style>
